<section class="section">
	<a class="banner"
	   [href]="humandUrl"
	   target="_blank"
	   rel="noopener noreferrer"
	   aria-label="Humand"
	   gtagEvent="ingresar-humand"
	   gtagCategory="humand-banner">
		<img class="banner__deco banner__deco--left" src="/assets/images/humand/banner-izq.png" alt="" aria-hidden="true">
		<span class="banner__brand">humand</span>
		<img class="banner__deco banner__deco--right" src="/assets/images/humand/banner-der.png" alt="" aria-hidden="true">
	</a>
</section>
